import type { PropsWithChildren } from "react";
import type { ReportContextType } from "./ReportsManagerContext";
import { ReportsManagerContext } from "./ReportsManagerContext";

export const ReportsManagerContextProvider = ({ children, ...props }: PropsWithChildren<ReportContextType>) => {
  return <ReportsManagerContext value={props}>{children}</ReportsManagerContext>;
};
